import { FC } from "react";
import Icon from ".";
import { IconElementProps, createIconVariantMap } from "./Icon.types";

export const Filled12 = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M10.5 1C10.7761 1 11 1.22386 11 1.5V10.5C11 10.7761 10.7761 11 10.5 11C10.2239 11 10 10.7761 10 10.5V1.5C10 1.22386 10.2239 1 10.5 1Z" fill="currentColor" />
      <path d="M1 6C1 5.72386 1.22386 5.5 1.5 5.5H7.29289L4.64645 2.85355C4.45118 2.65829 4.45118 2.34171 4.64645 2.14645C4.84171 1.95118 5.15829 1.95118 5.35355 2.14645L8.85355 5.64645C8.94732 5.74022 9 5.86739 9 6C9 6.13261 8.94732 6.25979 8.85355 6.35355L5.35355 9.85355C5.15829 10.0488 4.84171 10.0488 4.64645 9.85355C4.45118 9.65829 4.45118 9.34171 4.64645 9.14645L7.29289 6.5H1.5C1.22386 6.5 1 6.27614 1 6Z" fill="currentColor" />
    </svg>
  );
};

export const Filled16 = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M13.9999 1.33301C14.3681 1.33301 14.6666 1.63148 14.6666 1.99967V13.9997C14.6666 14.3679 14.3681 14.6663 13.9999 14.6663C13.6317 14.6663 13.3333 14.3679 13.3333 13.9997V1.99967C13.3333 1.63148 13.6317 1.33301 13.9999 1.33301Z" fill="currentColor" />
      <path d="M1.33325 7.99967C1.33325 7.63148 1.63173 7.33301 1.99992 7.33301H9.72378L6.19518 3.80441C5.93483 3.54406 5.93483 3.12195 6.19518 2.8616C6.45553 2.60125 6.87764 2.60125 7.13799 2.8616L11.8047 7.52827C11.9297 7.65329 11.9999 7.82286 11.9999 7.99967C11.9999 8.17649 11.9297 8.34606 11.8047 8.47108L7.13799 13.1377C6.87764 13.3981 6.45553 13.3981 6.19518 13.1377C5.93483 12.8774 5.93483 12.4553 6.19518 12.1949L9.72378 8.66634H1.99992C1.63173 8.66634 1.33325 8.36786 1.33325 7.99967Z" fill="currentColor" />
    </svg>
  );
};

export const Filled20 = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M17.5001 1.66699C17.9603 1.66699 18.3334 2.04009 18.3334 2.50033V17.5003C18.3334 17.9606 17.9603 18.3337 17.5001 18.3337C17.0398 18.3337 16.6667 17.9606 16.6667 17.5003V2.50033C16.6667 2.04009 17.0398 1.66699 17.5001 1.66699Z" fill="currentColor" />
      <path d="M1.66675 10.0003C1.66675 9.54009 2.03984 9.16699 2.50008 9.16699H12.1549L7.74416 4.75625C7.41872 4.43081 7.41872 3.90317 7.74416 3.57774C8.0696 3.2523 8.59723 3.2523 8.92267 3.57774L14.756 9.41107C14.9123 9.56735 15.0001 9.77931 15.0001 10.0003C15.0001 10.2213 14.9123 10.4333 14.756 10.5896L8.92267 16.4229C8.59723 16.7484 8.0696 16.7484 7.74416 16.4229C7.41872 16.0975 7.41872 15.5698 7.74416 15.2444L12.1549 10.8337H2.50008C2.03984 10.8337 1.66675 10.4606 1.66675 10.0003Z" fill="currentColor" />
    </svg>
  );
};

export const Outlined12 = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M10.5 1C10.7761 1 11 1.22386 11 1.5V10.5C11 10.7761 10.7761 11 10.5 11C10.2239 11 10 10.7761 10 10.5V1.5C10 1.22386 10.2239 1 10.5 1Z" fill="currentColor" />
      <path d="M1 6C1 5.72386 1.22386 5.5 1.5 5.5H7.29289L4.64645 2.85355C4.45118 2.65829 4.45118 2.34171 4.64645 2.14645C4.84171 1.95118 5.15829 1.95118 5.35355 2.14645L8.85355 5.64645C8.94732 5.74022 9 5.86739 9 6C9 6.13261 8.94732 6.25979 8.85355 6.35355L5.35355 9.85355C5.15829 10.0488 4.84171 10.0488 4.64645 9.85355C4.45118 9.65829 4.45118 9.34171 4.64645 9.14645L7.29289 6.5H1.5C1.22386 6.5 1 6.27614 1 6Z" fill="currentColor" />
    </svg>
  );
};

export const Outlined16 = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M13.9999 1.33301C14.3681 1.33301 14.6666 1.63148 14.6666 1.99967V13.9997C14.6666 14.3679 14.3681 14.6663 13.9999 14.6663C13.6317 14.6663 13.3333 14.3679 13.3333 13.9997V1.99967C13.3333 1.63148 13.6317 1.33301 13.9999 1.33301Z" fill="currentColor" />
      <path d="M1.33325 7.99967C1.33325 7.63148 1.63173 7.33301 1.99992 7.33301H9.72378L6.19518 3.80441C5.93483 3.54406 5.93483 3.12195 6.19518 2.8616C6.45553 2.60125 6.87764 2.60125 7.13799 2.8616L11.8047 7.52827C11.9297 7.65329 11.9999 7.82286 11.9999 7.99967C11.9999 8.17649 11.9297 8.34606 11.8047 8.47108L7.13799 13.1377C6.87764 13.3981 6.45553 13.3981 6.19518 13.1377C5.93483 12.8774 5.93483 12.4553 6.19518 12.1949L9.72378 8.66634H1.99992C1.63173 8.66634 1.33325 8.36786 1.33325 7.99967Z" fill="currentColor" />
    </svg>
  );
};

export const Outlined20 = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M17.5001 1.66699C17.9603 1.66699 18.3334 2.04009 18.3334 2.50033V17.5003C18.3334 17.9606 17.9603 18.3337 17.5001 18.3337C17.0398 18.3337 16.6667 17.9606 16.6667 17.5003V2.50033C16.6667 2.04009 17.0398 1.66699 17.5001 1.66699Z" fill="currentColor" />
      <path d="M1.66675 10.0003C1.66675 9.54009 2.03984 9.16699 2.50008 9.16699H12.1549L7.74416 4.75625C7.41872 4.43081 7.41872 3.90317 7.74416 3.57774C8.0696 3.2523 8.59723 3.2523 8.92267 3.57774L14.756 9.41107C14.9123 9.56735 15.0001 9.77931 15.0001 10.0003C15.0001 10.2213 14.9123 10.4333 14.756 10.5896L8.92267 16.4229C8.59723 16.7484 8.0696 16.7484 7.74416 16.4229C7.41872 16.0975 7.41872 15.5698 7.74416 15.2444L12.1549 10.8337H2.50008C2.03984 10.8337 1.66675 10.4606 1.66675 10.0003Z" fill="currentColor" />
    </svg>
  );
};

export const variants = createIconVariantMap({
  filled: {
    12: Filled12,
    16: Filled16,
    20: Filled20,
  },
  outlined: {
    12: Outlined12,
    16: Outlined16,
    20: Outlined20,
  },
});

export const IconLastPage: FC<IconElementProps & { className?: string }> = (props) => (
  <Icon name={"last-page"} {...props} />
);
